<template>
  <div :class="['rounded-md p-4 mb-2', wrapperClass]">
    <div class="flex">
      <!-- <div class="flex-shrink-0">
        <ExclamationIcon :class="['h-5 w-5', iconClass ]" aria-hidden="true" />
      </div> -->
      <div class="ml-3">
        <h3 :class="[' font-bold', headingClass ]">
          {{ $props.heading }}
        </h3>
        <div :class="['mt-2 ', textClass ]">
          <p>
            <slot />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

type AlertDisplayProps = {
  variant: 'success' | 'info' | 'warning' | 'danger' | 'error',
  heading: string;
}

const props = withDefaults(defineProps<AlertDisplayProps>(), {
  variant: 'success',
})

const wrapperClass = computed(() => {
  return {
      'border border-green-300 bg-green-50': props.variant === 'success',
      'border border-blue-300 bg-blue-50': props.variant === 'info',
      'border border-yellow-300 bg-yellow-50': props.variant === 'warning',
      'border border-red-300 bg-red-50': props.variant === 'danger' || props.variant === 'error',
    };
});

const headingClass = computed(() => {
  return {
    'text-green-800': props.variant === 'success',
    'text-blue-800': props.variant === 'info',
    'text-yellow-800': props.variant === 'warning',
    'text-red-800': props.variant === 'danger',
  };
});

const textClass = computed(() => {
  return {
    'text-green-700': props.variant === 'success',
    'text-blue-700': props.variant === 'info',
    'text-yellow-700': props.variant === 'warning',
    'text-red-700': props.variant === 'danger',
  };
});

// const iconClass = computed(() => {
//   return {
//     'text-green-400': props.variant === 'success',
//     'text-blue-400': props.variant === 'info',
//     'text-yellow-400': props.variant === 'warning',
//     'text-red-400': props.variant === 'danger',
//   };
// });
</script>
